(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fitmar-ecomail-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('fitmar-newsletter-popup');
    if (!popup || popup.dataset.initialized || typeof popup.showModal !== 'function') return;
    popup.dataset.initialized = 'true';
    const market = popup.dataset.market;
    if (!['cz', 'sk'].includes(market)) return;
    if (market === 'sk' && matchMedia('(min-width: 761px)').matches && location.pathname.includes('/2plus1')) return;
    if (/^\/(cart|checkout|account)(\/|$)/.test(location.pathname)) return;
    const key = 'fitmar_newsletter_popup_v1';
    const read = () => { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch { return {}; } };
    const save = (value) => { try { localStorage.setItem(key, JSON.stringify({ ...read(), ...value })); } catch {} };
    const suppressed = () => { const state = read(); return state.subscribed || Date.now() - (state.dismissed || 0) < 86400000; };
    if (suppressed()) return;
    const intro = popup.querySelector('[data-fm-intro]');
    const signup = popup.querySelector('[data-fm-signup]');
    const success = popup.querySelector('[data-fm-success]');
    const slot = popup.querySelector('[data-fm-widget]');
    let widget, anchor, previousFocus, previousOverflow, observer, didOpen = false;
    const confirmed = () => widget?.querySelector('.ec-v-form-step-send.ec-v-form-step-visible');
    const handleConfirmation = () => {
      if (!confirmed()) return;
      save({ subscribed: true });
      observer?.disconnect();
      if (!popup.open) return;
      intro.hidden = true; signup.hidden = true; success.hidden = false;
      popup.dataset.step = 'success';
      popup.setAttribute('aria-labelledby', 'fm-pop-success-title');
      const heading = success.querySelector('h2');
      heading.id = 'fm-pop-success-title'; heading.focus();
    };
    const close = () => {
      if (!popup.open) return;
      save({ dismissed: Date.now() });
      popup.close();
    };
    popup.querySelectorAll('[data-fm-close]').forEach(button => button.addEventListener('click', close));
    popup.addEventListener('cancel', event => { event.preventDefault(); close(); });
    popup.addEventListener('click', event => { if (event.target === popup) { const r = popup.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
    popup.addEventListener('close', () => {
      if (anchor?.isConnected && widget) anchor.replaceWith(widget);
      document.documentElement.style.overflow = previousOverflow || '';
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    });
    popup.querySelector('[data-fm-reveal]').addEventListener('click', () => {
      if (!widget?.isConnected) { close(); return; }
      anchor = document.createComment('FitMar newsletter widget position');
      widget.before(anchor); slot.append(widget);
      intro.hidden = true; signup.hidden = false; popup.dataset.step = 'signup';
      popup.setAttribute('aria-labelledby', 'fm-pop-offer-title');
      signup.querySelector('h2').focus({ preventScroll: true });
      handleConfirmation();
    });
    const cookiePanelOpen = () => {
      const root = document.querySelector('pandectes-cmp')?.shadowRoot;
      return [...(root?.querySelectorAll('button.allow, button.preferences') || [])].some(button => button.getBoundingClientRect().height > 0);
    };
    const started = Date.now();
    const attempt = () => {
      if (didOpen || suppressed() || Date.now() - started > 600000) return;
      widget = document.querySelector('.fitmar-ecomail-footer');
      const email = widget?.querySelector('input[name="ecmw[email]"]');
      if (!email || cookiePanelOpen() || document.querySelector('dialog[open]') || document.visibilityState !== 'visible') { setTimeout(attempt, 1000); return; }
      if (confirmed()) { save({ subscribed: true }); return; }
      if (email.value || widget.contains(document.activeElement)) return;
      const setCountry = () => {
        widget.querySelectorAll('input[name="ecmw[custom_fields[market_country]]"]').forEach(input => {
          input.value = market.toUpperCase();
          input.setAttribute('value', market.toUpperCase());
        });
      };
      setCountry();
      widget.addEventListener('submit', setCountry, true);
      observer = new MutationObserver(() => { setCountry(); handleConfirmation(); });
      observer.observe(widget, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      popup.showModal();
      document.documentElement.style.overflow = 'hidden';
      didOpen = true;
      popup.querySelector('[data-fm-reveal]').focus({ preventScroll: true });
    };
    setTimeout(attempt, 20000);
  })();
  } catch(e) { console.error(e); }
})();

})();
